import { render } from "./successDialog.vue?vue&type=template&id=566b0912&scoped=true"
import script from "./successDialog.vue?vue&type=script&lang=js"
export * from "./successDialog.vue?vue&type=script&lang=js"

import "./successDialog.vue?vue&type=style&index=0&id=566b0912&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566b0912"]])

export default __exports__